import PropTypes from "prop-types"

const TranslationsHeader = ({ options }) => {
  return (
    <div className="flex">
      <div className="w-[90%] flex px-4 gap-8 mt-8 rounded-md text-[12px] text-primary uppercase font-bold">
        {options.map((option) => {
          return (
            <div key={option.id} className="w-1/3">
              {option.label}
            </div>
          )
        })}
      </div>
      <div className="w-[10%]" />
    </div>
  )
}

TranslationsHeader.propTypes = {
  options: PropTypes.array,
}

export default TranslationsHeader
